/**
 * 邮箱
 * @param {*} s
 */
 export function isEmail (s) {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  return /^1[3-9][0-9]{9}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}

export function isvalidUsername (str) {
  const validMap = ['admin', 'editor']
  return validMap.indexOf(str.trim()) >= 0
}

/* 合法uri */
export function validateURL (textVal) {
  const urlRegex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlRegex.test(textVal)
}

/* 小写字母 */
export function validateLowerCase (str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母 */
export function validateUpperCase (str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母 */
export function validatAlphabets (str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
  密码规则是：1、长度8~20

                      2、必须包含字母（大写或者小写）

                      3、必须包含数字

                      4、包含特殊字符 ~!@#$%^&*()[]{}<>?\+    不能包含空格

                      5、只能包含以上特殊字符以及大小字母和数字的密码。
  ————————————————
  版权声明：本文为CSDN博主「myjie0527」的原创文章，遵循CC 4.0 BY-SA版权协议，转载请附上原文出处链接及本声明。
  原文链接：https://blog.csdn.net/myjie0527/article/details/90707308
**/
export const validatePasswordMessage = '必须包含大写字母、小写字母、数字且长度在12到20位'
export function validatePassword (str) {
  // return RegExp('^(?=.*\\d)(?=.*[a-zA-Z])(?=.*[\\~\\!\\@\\#\\$\\%\\^\\&\\*\\(\\)\\[\\]\\{\\}\\<\\>\\?\\\\\\+])[a-zA-Z0-9\\~\\!\\@\\#\\$\\%\\^\\&\\*\\(\\)\\[\\]\\{\\}\\<\\>\\?\\\\\\+]{8,20}$').test(str)
  return RegExp('^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9\\~\\!\\@\\#\\$\\%\\^\\&\\*\\(\\)\\[\\]\\{\\}\\<\\>\\?\\\\\\+]{12,20}$').test(str)
  // 方便测试
  // return true
  /* 密码包含 数字,英文,字符中的两种以上，长度6-20 */
  // return /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,20}$/.test(str)
}

/* 验证pad还是pc */
export const vaildatePc = function () {
  const userAgentInfo = navigator.userAgent
  const Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod'
  ]
  let flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail (email) {
  const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * 判断身份证号码
 */
export function isCardId (code) {
  if (code.length < 18) return false
  const iW = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1 ]
  let iSum = 0
  for (let i = 0; i < 17; i++) {
      const iVal = Number(code[i]) || 0
      iSum += iVal * iW[i]
  }

  const iCheck = iSum % 11

  let check = ''

  switch (iCheck) {
      case 0: check = '1'; break
      case 1: check = '0'; break
      case 2: check = 'x'; break
      case 3: check = '9'; break
      case 4: check = '8'; break
      case 5: check = '7'; break
      case 6: check = '6'; break
      case 7: check = '5'; break
      case 8: check = '4'; break
      case 9: check = '3'; break
      case 10: check = '2'; break
  }

  const valid = code[17].toLowerCase()

  return valid === check
}

export function cardid (code) {
  const list = []
  let result = true
  let msg = ''
  var city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  }
  if (!validatenull(code)) {
    if (code.length === 18) {
      if (!code || !/(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code)) {
        msg = '证件号码格式错误'
      } else if (!city[code.substr(0, 2)]) {
        msg = '地址编码错误'
      } else {
        // 18位身份证需要验证最后一位校验位
        code = code.split('')
        // ∑(ai×Wi)(mod 11)
        // 加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        // 校验位
        var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2, 'x']
        var sum = 0
        var ai = 0
        var wi = 0
        for (var i = 0; i < 17; i++) {
          ai = code[i]
          wi = factor[i]
          sum += ai * wi
        }
        if (parity[sum % 11] !== code[17]) {
          msg = '证件号码校验位错误'
        } else {
          result = false
        }
      }
    } else {
      msg = '证件号码长度不为18位'
    }
  } else {
    msg = '证件号码不能为空'
  }
  list.push(result)
  list.push(msg)
  return list
}

/**
 * 判断手机号码是否正确
 */
export function isvalidatemobile (phone) {
  const list = []
  let result = true
  let msg = ''
  var isPhone = /^0\d{2,3}-?\d{7,8}$/
  // 增加134 减少|1349[0-9]{7}，增加181,增加145，增加17[678]
  if (!validatenull(phone)) {
    if (phone.length === 11) {
      if (isPhone.test(phone)) {
        msg = '手机号码格式不正确'
      } else {
        result = false
      }
    } else {
      msg = '手机号码长度不为11位'
    }
  } else {
    msg = '手机号码不能为空'
  }
  list.push(result)
  list.push(msg)
  return list
}

/**
 * 判断手机号码是否正确（可以为空）
 */
export function isValidateNoneMobile (phone) {
  const list = []
  let result = true
  let msg = ''
  var isPhone = /^0\d{2,3}-?\d{7,8}$/
  // 增加134 减少|1349[0-9]{7}，增加181,增加145，增加17[678]
  if (!validatenull(phone)) {
    if (phone.length === 11) {
      if (isPhone.test(phone)) {
        msg = '手机号码格式不正确'
      } else {
        result = false
      }
    } else {
      msg = '手机号码长度不为11位'
    }
  } else {
    result = false
  }
  list.push(result)
  list.push(msg)
  return list
}

/**
 * 判断姓名是否正确
 */
export function validatename (name) {
  var regName = /^[\u4e00-\u9fa5]{2,4}$/
  if (!regName.test(name)) return false
  return true
}

/**
 * 判断是否为整数
 */
export function validatenum (num, type) {
  let regName = /[^\d.]/g
  if (type === 1) {
    if (!regName.test(num)) return false
  } else if (type === 2) {
    regName = /[^\d]/g
    if (!regName.test(num)) return false
  }
  return true
}

export function isPositiveInteger (num) {
  return /^[1-9]\d*$/.test(num)
}

export function isPrice (num) {
  const reg = '^(([1-9]{1}\\d*)|([0]{1}))(\\.(\\d){0,2})?$'
  return RegExp(reg).test(num)
}

/**
 * 判断是否为小数
 */
export function validatenumord (num, type) {
  let regName = /[^\d.]/g
  if (type === 1) {
    if (!regName.test(num)) return false
  } else if (type === 2) {
    regName = /[^\d.]/g
    if (!regName.test(num)) return false
  }
  return true
}

/**
 * 判断是否为空
 */
export function validatenull (val) {
  if (typeof val === 'boolean') {
    return false
  }
  if (typeof val === 'number') {
    return false
  }
  if (val instanceof Array) {
    if (val.length === 0) return true
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true
  } else {
    if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') return true
    return false
  }
  return false
}

// 银行卡号

// 参考 https://blog.csdn.net/weixin_43838488/article/details/106761134
export function bankNoCheck (bankno) {
  if (!/^\d+$/.test(bankno)) {
    return false
  }
  return true

  // var lastNum = bankno.substr(bankno.length - 1, 1) // 取出最后一位（与luhn进行比较）
  // var first15Num = bankno.substr(0, bankno.length - 1) // 前15或18位
  // var newArr = []
  // for (var i = first15Num.length - 1; i > -1; i--) { // 前15或18位倒序存进数组
  //     newArr.push(first15Num.substr(i, 1))
  // }
  // var arrJiShu = [] // 奇数位*2的积 <9
  // var arrJiShu2 = [] // 奇数位*2的积 >9
  // var arrOuShu = [] // 偶数位数组
  // for (var j = 0; j < newArr.length; j++) {
  //     if ((j + 1) % 2 === 1) { // 奇数位
  //         if (parseInt(newArr[j]) * 2 < 9) arrJiShu.push(parseInt(newArr[j]) * 2)
  //         else arrJiShu2.push(parseInt(newArr[j]) * 2)
  //     } else {
  //       arrOuShu.push(newArr[j])
  //     }
  // }

  // // eslint-disable-next-line camelcase
  // var jishu_child1 = [] // 奇数位*2 >9 的分割之后的数组个位数
  // // eslint-disable-next-line camelcase
  // var jishu_child2 = [] // 奇数位*2 >9 的分割之后的数组十位数
  // for (var h = 0; h < arrJiShu2.length; h++) {
  //     jishu_child1.push(parseInt(arrJiShu2[h]) % 10)
  //     jishu_child2.push(parseInt(arrJiShu2[h]) / 10)
  // }
  // var sumJiShu = 0 // 奇数位*2 < 9 的数组之和
  // var sumOuShu = 0 // 偶数位数组之和
  // var sumJiShuChild1 = 0 // 奇数位*2 >9 的分割之后的数组个位数之和
  // var sumJiShuChild2 = 0 // 奇数位*2 >9 的分割之后的数组十位数之和
  // var sumTotal = 0
  // for (var m = 0; m < arrJiShu.length; m++) {
  //     sumJiShu = sumJiShu + parseInt(arrJiShu[m])
  // }
  // for (var n = 0; n < arrOuShu.length; n++) {
  //     sumOuShu = sumOuShu + parseInt(arrOuShu[n])
  // }
  // for (var p = 0; p < jishu_child1.length; p++) {
  //     sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p])
  //     sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p])
  // }
  // // 计算总和
  // sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2)
  // // 计算luhn值
  // var k = parseInt(sumTotal) % 10 === 0 ? 10 : parseInt(sumTotal) % 10
  // var luhn = 10 - k
  // if (lastNum === luhn) {
  //     // $("#banknoInfo").html("luhn验证通过");
  //     return true
  // } else {
  //     // $("#banknoInfo").html("银行卡号必须符合luhn校验");
  //     return false
  // }
}
